var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorkplaceSafety(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99983 1.5C12.3357 3.56658 15.3843 4.64257 18.4998 4.5C18.9534 6.04302 19.0922 7.66147 18.908 9.25918C18.7237 10.8569 18.2202 12.4013 17.4272 13.8005C16.6343 15.1998 15.5682 16.4254 14.2923 17.4045C13.0164 18.3836 11.5566 19.0962 9.99983 19.5M9.99983 1.5C7.664 3.56658 4.61536 4.64257 1.49983 4.5C1.04624 6.04302 0.907451 7.66147 1.09171 9.25918C1.27597 10.8569 1.77952 12.4013 2.57243 13.8005C3.36534 15.1998 4.43144 16.4254 5.70738 17.4045C6.98331 18.3836 8.44305 19.0962 9.99983 19.5M9.99983 1.5V19.5M10 9.5H18.9M10 6.5H18.9M10 3.5H13.1M10 15.5H16.2M10 12.5H18",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkplaceSafety);
export default __webpack_public_path__ + "static/media/workplace_safety.0868022e62e6f99b4d475c70c1d07e91.svg";
export { ForwardRef as ReactComponent };